import $fetch from '@/services/client'

async function listStates(isocode: string) {
  const response = await $fetch('dealers/list-dealer-states-by-country/:isocode/json', {
    params: {
      isocode,
    },
  })

  if (response.error) throw new Error(response.error.statusText + response.error.message)

  // Edge case: If no states returned (e.g., for Japan), return a fallback empty state
  if (!response.data.data || response.data.data.length === 0) {
    return [{ state: ' ' }]
  }

  return response.data.data
}

export default listStates
